/* global customElements, Service */

import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../service/service.js';

class MainFooter extends LitElement {
	
	static get properties() {
		return {
			about: {type: String},
			version: {type: String}
		};
	}

	constructor() {
		super();
		this.about = '';
		this.version = '';	
		this.getVersion();
	}
	
	render() {		
		return html`
			<style>
				.footer {
					text-align: center;
					width: 100%;
					color: ${this.getTextColor()};
					background-color: ${this.getBackgroundColor()}; 
					border-top: 2px solid ${this.getAccentColor()};
					padding: 5px;
					position: fixed;
					bottom: 0px;
					box-shadow: 1px -1px 10px 0px black;
				}
		
				@media only screen and (max-width: 600px) {
					.footer {
						font-size: 10px;
					}
				}
		
			</style>
			<div class="footer">
				${this.version} - &copy ${this.getCurrentYear()} ${this.getCompanyText()}
			</div>
		`;
	}
	
	getCurrentYear() {
		return new Date(Date.now()).getFullYear();
	}
	
	async getVersion() {
		var versionText = await Service.getApplicationService().getCurrentVersion();
		this.version = versionText;
	}
	
	getCompanyText() {
		return window.DL.Branding.footerCompany;
	}
	
	getBackgroundColor() {
		return window.DL.Branding.headerBackgroundColor;	
	}
	
	getTextColor() {
		return window.DL.Branding.headerTextColor;
	}

	getAccentColor() {
		return window.DL.Branding.navBackgroundColor;	
	}

};

customElements.define('dl-main-footer', MainFooter);


